
import { computed, ComputedRef, defineComponent, Ref, ref } from "vue";
import { useStore } from 'vuex';
import { StateType as GlobalStateType } from '@/store/global';
import { SettingOutlined } from '@ant-design/icons-vue';

interface SettingsSetupData {
    visible: Ref<boolean>;
    close: () => void;
    show: () => void;
    topNavEnable: ComputedRef<boolean>;
    onChangeTopNavEnable: (v: boolean) => void;
    tabNavEnable: ComputedRef<boolean>;
    onChangeTabNavEnable: (v: boolean) => void;
    headFixed: Ref<boolean>;
    onChangeHeadFixed: (v: boolean) => void;
    disabledHeadFixed: Ref<boolean>;
}

export default defineComponent({
    name: 'Settings',
    components: {
        SettingOutlined
    },
    setup(): SettingsSetupData {
        
        const store = useStore<{global: GlobalStateType}>(); 

        const visible = ref<boolean>(false);
        // 关闭
        const close = (): void => {
            visible.value = false;
        }
        // 显示
        const show = (): void => {
            visible.value = true;
        }

        // 固定右侧头部
        const disabledHeadFixed = ref<boolean>(true);
        const headFixed = computed<boolean>(()=> store.state.global.headFixed);
        const onChangeHeadFixed = (v: boolean): void => {
            store.commit('global/setHeadFixed', v);
        }

        // 启用顶部导航
        const topNavEnable = computed<boolean>(()=> store.state.global.topNavEnable);
        const onChangeTopNavEnable = (v: boolean): void => {
            store.commit('global/setTopNavEnable', v);

            if (v) {
                disabledHeadFixed.value = true;
                onChangeHeadFixed(true);
            } else {
                disabledHeadFixed.value = false;
            }

        }   
        
        
        // 启用TabNav
        const tabNavEnable = computed<boolean>(()=> store.state.global.tabNavEnable);
        const onChangeTabNavEnable = (v: boolean): void => {
            store.commit('global/setTabNavEnable', v);
        }  


        return {
            visible,
            close,
            show,
            topNavEnable,
            onChangeTopNavEnable,
            tabNavEnable,
            onChangeTabNavEnable,
            headFixed,
            onChangeHeadFixed,
            disabledHeadFixed
        }

    }
})
